<template>
<div id="login" class="loginbg">
    <v-content>
        <v-layout>
            <v-flex xs12>
                <a href="https://loadmax.com" > <img src="/static/loadmaxlogo.png" alt="LoadMax" height="40" class="lgImg"></a>
            </v-flex>
        </v-layout>
        <v-container fluid fill-height class="">
            <v-layout align-center justify-center class="logintype-anchor">
                <v-flex xs12 sm8 md3 lg3>
                    <template v-if="loginType == imrUserStr">
                        <img src="/static/maxmarketing.png" alt="LoadMax" height="30" class="lgImg">
                    </template>
                    <v-card class="elevation-1 pa-3" v-if="isForm">
                        <v-card-text>
                            <div class="layout column ">
                                <h1 class="flex">Reset Password</h1>
                            </div>
                            <v-form>

                                <v-text-field v-validate="{required: 'password', max: 15, min: 8,'restrictedWord':[]}" :error-messages="errors.collect('password')"  name="password" label="Password" ref="password" type="password" v-model="form.password" data-vv-as="Password">
                                </v-text-field>

                                <v-text-field v-validate="'required|confirmed:password'" :error-messages="errors.collect('confirm_password')"  name="confirm_password" label="Confirm Password" type="password" v-model="form.confirm_password" data-vv-as="Confirm Password">
                                </v-text-field>

                            </v-form>
                        </v-card-text>
                          <v-card-actions>
                            <v-btn block color="orange darken-1 white--text" @click="ResetPassword">Submit</v-btn>
                        </v-card-actions>
                        <v-flex align-end class="signup">
                            Back to LOADMAX? 
                            <template v-if="loginType != imrUserStr">
                                <router-link :to="{name:'Login'}" class="links">Sign in</router-link>
                            </template>
                            <template v-if="loginType == imrUserStr">
                                <router-link to="/login/imr" class="links">Login</router-link>
                            </template>
                        </v-flex>
                    </v-card>
                     <v-card class="elevation-1 pa-3" v-if="isError">
                      <v-card-text title="Basic Usage">
                            <div slot="widget-content">
                                <v-alert type="error" :value="true">
                                    {{this.errorMesage}}
                                </v-alert>
                            </div>
                            <v-flex align-end class="text-md-center ">
                                <template v-if="loginType != imrUserStr">
                                    <router-link :to="{name:'Login'}" class="links">Login</router-link>
                                </template>
                                <template v-if="loginType == imrUserStr">
                                    <router-link to="/login/imr" class="links">Login</router-link>
                                </template>
                            </v-flex>
                        </v-card-text>
                        <v-flex align-end class="signup" v-if="loginType != imrUserStr">
                            New to LOADMAX? <a href="https://loadmax.com/signup/" class="links"> Sign up now</a>
                        </v-flex>
                    </v-card>
                    <v-flex align-end class="text-md-center my-4 ">
                        <span class="calltxt">Questions? Call 1-866-925-6608</span>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>


<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import services from "../services/HttpService";
import axios from "axios";
import config from '../config';
export default {
    data: () => ({
        form: {
            password: "",
            confirm_password: "",
        },
        isError: false,
        isForm: false,
        errorMesage: '',
        loginType:'',
        imrUserStr:config.imrUserStr
    }),
    mounted() {},
    created() {
        const self = this;
        if(self.$route.meta.type){
            self.loginType = self.$route.meta.type;
            if(self.loginType == config.imrUserStr){
                self.updateLoginType({
                    loginType:self.loginType
                })
            }
        }else{
            self.updateLoginType({
                loginType:null
            })
        }
        axios.all([
                services.post("users/forgotPasswordValidateToken", {
                    token: this.$route.params.token
                }),
            ])
            .then(axios.spread(function (res) {
                if (res.data.data.status) {
                    self.isForm = true;
                    self.isError = false;
                    self.errorMesage = '';
                } else {
                    self.isForm = false;
                    self.isError = true;
                    self.errorMesage = res.data.data.msg;
                }
            }));
    },
    methods: {
        ...mapActions([
            "updateLoginType"
        ]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        ResetPassword(e) {
            
            const self = this;
            
            self.$validator
                .validateAll()
                .then(isValid => {
                    // Data is valid, so we can login now
                    if (isValid) {
                        services.post("users/setPasswordByToken", {
                                "token": this.$route.params.token,
                                "password": self.form.password
                            })
                            .then(res => {
                                self._showToast(res.data.message);
                                let loginUrl = '/login';
                                if(self.$store.state.loginType && self.$store.state.loginType != ''){
                                    loginUrl += '/'+self.$store.state.loginType;
                                }
                                self.$router.push(loginUrl);
                            })
                            .catch(err => {
                                self._showToast(err.message, "red");
                            });
                    }
                })
                .catch(e => {
                    return false;
                });
        }
    }
};
</script>

<style lang="css" scoped>
#login {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
.logintype-anchor{
    text-align:center !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/ResetPassword.vue